import { AccordionSummary, styled, Theme, Button as MuiButton } from '@material-ui/core';

export const StyledAccordionSummary = styled(AccordionSummary)<Theme>(({ theme }) => ({
  // backgroundColor: theme.palette.grey[100],
  cursor: 'default',
  fontSize: 16,
  fontWeight: 600,
}));

export const StyledMuiButton = styled(MuiButton)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  color: '#228095',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 600,
  '&:hover': {
    background: 'none',
  },
}));

export const StyledContainer = styled('div')({
  width: '100%',
  flex: 1,
});

export const TeacherSolutionContainer = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(3, 2),
  marginBottom: theme.spacing(1),
  borderBottom: `0.1rem solid ${theme.palette.grey['100']}`,
}));

export const StyleTeacherTitle = styled('h4')<Theme>(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  fontWeight: 600,
  marginBottom: theme.spacing(2),
}));
